export default __webpack_public_path__ + "static/media/apple-tv.03f04de0.svg";